import React, { Component } from "react";
import { Pie } from "react-chartjs-2";
import { Card, CardBody, CardText } from "reactstrap";
import {getMessage} from "./util";


const grouped = [
    {
        name: 'Administrativo',
        districts: ['D02'],
        ponderador: 0.63
    },
    {
        name: 'Docente - Oficio',
        districts: ['D01'],
        ponderador: 1
    },
    {
        name: 'Estudiantil',
        districts: ['D03'],
        ponderador: 1
    }]

class RolloutSummaryW extends Component {


    render() {

        const totals_grouped = grouped.reduce((accg, g) => {
            const suma_grupo = g.districts.reduce((acc, elem) => {
                return ([acc[0] + this.props.snapshot.districts[elem].voters.electronic_voted , acc[1] + this.props.snapshot.districts[elem].voters.ready ]);
            }, [0,0]);
            return ([suma_grupo[0]* g.ponderador + accg[0], suma_grupo[1]* g.ponderador + accg[1] ]);
        }, [0,0]);
        var labels = [getMessage('label_ready',this.props.messages), getMessage('label_electronic_voted',this.props.messages)];
        var datain = [
            totals_grouped[1] /  this.props.election.configuration.advanced_config.factor,
            totals_grouped[0] /  this.props.election.configuration.advanced_config.factor
        ];

        if (this.props.snapshot.weighted.manual_voted > 0) {
            labels.push(getMessage('label_paper_voted',this.props.messages));
            datain.push(this.props.snapshot.weighted.manual_voted /  this.props.election.configuration.advanced_config.factor);
        }
        const data = {
            labels: labels,
            datasets: [
                {
                    data: datain,
                    backgroundColor: ["#C6CCD4", "#0B1224"],
                    hoverBackgroundColor: ["#C6CCD4", "#0B1224"]
                }
            ]
        };

        const chartOptions = {
            legend: {
                position: "top"
            }
        };

        return (
            <div>
                <div className="row">
                    <div className="col-12 col-sm-8">
                        <Pie data={data} options={chartOptions} />
                    </div>
                    <div className="col-12 col-sm-4">
                        <div className="row justify-content-center">
                            <div className="col-6 col-sm-10 mt-2">
                                <BoxInfo
                                    percentage={(
                                        (100 * (totals_grouped[0])) /
                                        (totals_grouped[0] + totals_grouped[1])

                                    )
                                        .toFixed(2)
                                        .toLocaleString(navigator.language, {
                                            maximumFractionDigits: 2, minimumFractionDigits: 2
                                        })}
                                    progress={(
                                        totals_grouped[0] / this.props.election.configuration.advanced_config.factor
                                    ).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2, minimumFractionDigits: 2
                                    })}
                                    total={(
                                        (totals_grouped[1] + totals_grouped[0] ) / this.props.election.configuration.advanced_config.factor
                                    ).toLocaleString(navigator.language, {
                                        maximumFractionDigits: 2, minimumFractionDigits: 2
                                    })}
                                    label={getMessage('total_weighted',this.props.messages)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


class BoxInfo extends Component {
    render() {
        return (
            <div>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.percentage} %</b>
                            <br />({this.props.progress} de {this.props.total})<br />
                            {this.props.label}
                        </CardText>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default RolloutSummaryW;